import * as React from 'react';
import { Link } from 'react-router-dom';
import { Anchor, Box, Button, Text } from '@moosend/mooskin';
import { PermissionsAndLimitsContexts } from '..';

export interface INoItemsProps {
	image?: string;
	message?: string;
	description?: string | React.ReactElement;
	button?: {
		text: string;
		link?: string;
		onClick?: () => void;
	};
	isTransactionalCampaign?: boolean;
	isSitecoreUser?: boolean;
}

export const NoItemsLink = ({ link, text, onClick, plan }: { link?: string; text: string; onClick?: () => void; plan?: string }) => {
	if (link) {
		if (plan) {
			const { withLimitNotificationUpgrade, PermissionsCheck } = PermissionsAndLimitsContexts;
			const LinkWithLimits = withLimitNotificationUpgrade(Link, { code: plan, value: 0 || 0 });
			return (
				<LinkWithLimits to={link}>
					<Button mt={10}>{text}</Button>
				</LinkWithLimits>
			);
		}
		return (
			<Link to={link}>
				<Button mt={10}>{text}</Button>
			</Link>
		);
	}
	if (onClick) {
		return (
			<Button mt={10} onClick={onClick}>
				{text}
			</Button>
		);
	}

	return null;
};

export const NoItems: React.FC<INoItemsProps> = ({ image, message, button, description, isTransactionalCampaign, isSitecoreUser }) => {
	const moreInformationElement: JSX.Element | null = isSitecoreUser ? null : (
		<>
			Find more information{' '}
			<Anchor
				target="_blanc"
				fontColor="fontColors.primary1"
				textDecoration="none"
				fontSize={13}
				fontWeight={400}
				href={'https://moosend.com/blog/transactional-emails-announcement/'}
			>
				here.
			</Anchor>
		</>
	);

	return (
		<Box d="flex" direction="column" justify="center" align="center" m="20px 0" noRender={['sm', 'xs']}>
			{image && <img src={image} width={400} />}
			{message && (
				<Text fontSize={20} my={30} fontColor="fontColors.medgray1" textTransform="capitalize">
					{message}
				</Text>
			)}
			{description && (
				<Text fontSize={16} fontColor="#9d9d9d">
					{description}
				</Text>
			)}
			{isTransactionalCampaign && (
				<Box d="block" maxW="1000px" p="10px" fontSize={14} fontColor="#9d9d9d" align="center">
					Transactional emails are messages that are triggered by specific user actions or events. These emails typically include
					confirmations, notifications, receipts, reminders, or updates regarding transactions, account activities, password resets, and
					other essential communications. {moreInformationElement}
				</Box>
			)}
			{button?.text && (
				<NoItemsLink
					link={button.link}
					text={button.text}
					onClick={button.onClick}
					plan={isTransactionalCampaign ? 'transactional.api' : undefined}
				/>
			)}
		</Box>
	);
};
